import { useAccount, useMsal } from '@azure/msal-react';
import { get } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { selectStoredActiveRole, switchActiveRole } from './active-role.slice';
import { resolveActiveRole } from './active-role-utils';
import { UserGroups } from './constants';

// Usable outside LubaUserProvider (the header renders above it) — claims come straight from MSAL.
export const useActiveRole = () => {
  const { accounts, instance } = useMsal();
  const currentAccount = instance.getActiveAccount() || get(accounts, '[0]');
  const accountInfo = useAccount(currentAccount);
  const idTokenClaims = get(accountInfo, 'idTokenClaims');
  const userRoles = get(idTokenClaims, 'roles', []);

  const dispatch = useDispatch();
  const storedRole = useSelector(selectStoredActiveRole);
  const activeRole = resolveActiveRole(storedRole, userRoles);

  return {
    idTokenClaims,
    userRoles,
    activeRole,
    isActiveAdmin: activeRole === UserGroups.Admins,
    switchRole: (role) => dispatch(switchActiveRole(role)),
  };
};
